/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Meta_DescriptionInputs */

const en_svc_research_meta_description = /** @type {(inputs: Svc_Research_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom AI research agents for market, competitor and prospect research: they gather and check sources and hand back briefs where every claim is cited.`)
};

const lv_svc_research_meta_description = /** @type {(inputs: Svc_Research_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI izpētes aģenti tirgus, konkurentu un potenciālo klientu izpētei: tie savāc un pārbauda avotus un nodod kopsavilkumus, kuros katrs apgalvojums ir ar avotu.`)
};

/**
* | output |
* | --- |
* | "Custom AI research agents for market, competitor and prospect research: they gather and check sources and hand back briefs where every claim is cited." |
*
* @param {Svc_Research_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_meta_description = /** @type {((inputs?: Svc_Research_Meta_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Meta_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_meta_description(inputs)
	return en_svc_research_meta_description(inputs)
});